export const documentsData = {
  'INFORMED_CONSENT': {
    'es-ES': {
      documentId: '2657ce12-d27e-483f-94f2-b148053b9978',
      finalUrl: '/informeDetallado/${patientId}/${reportId}/paymentMethod',
      urlParams: {
        patientId: 'patientId',
        reportId: 'reportId',
      },
      data: {
        tutorFullName: '',
        tutorId: '',
        patientCountryId: '',
        patientId: '',
        patientName: '',
        tutorEmail: '',
        carehomeName: '',
      },
    },
    'en-EN': {
      documentId: '',
      finalUrl: '',
      data: {

      },
       urlParams: {
        
      },
    },
    'it-IT': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
    'de-DE': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
    'fr-FR': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
  },
  'QUOTE': {
    'es-ES': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
    'en-EN': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
    'it-IT': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
    'de-DE': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
    'fr-FR': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
  },
  'SEPA': {
    'es-ES': {
      documentId: '0ef146f1-aa8a-497d-9f37-3db71bb9ee5a',
      finalUrl: '/personas',
      data: {
        tutorFullName: '',
        tutorId: '',
        patientCountryId: '',
        patientId: '',
        patientName: '',
        tutorEmail: '',
        carehomeName: '',
      },
      urlParams: {
        
      },
    },
    'en-EN': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
    'it-IT': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
    'de-DE': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
    'fr-FR': {
      documentId: '',
      finalUrl: '',
      data: {

      },
      urlParams: {
        
      },
    },
  }
};

export type DocumentCategory = keyof typeof documentsData;